module.exports = __webpack_public_path__ + "img/other.37d596d3.png";